//申請情報更新ラベル

export const LABELS = {
  COMPANY_NAME: "事業者名",
  CORP_NUMBER: "法人番号",
  COMPANY_ADDRESS: "事業者住所",
  MERCHANT_NAME: "加盟店名",
  APPLICATION_CONFIRM: "申請内容確認",
  COMMISSION_RATE: "手数料率",
  APPROVAL_STATUS: "承認状況",
  APPROVAL_DATE: "承認日",
  APPROVAL_PERSON: "承認者",
  IMPORTANT_CONFIRM_ITEMS: "加盟店申請内容に関する重点確認項目",
  NO_Defect: "不備なし",
  Defect: "不備あり",
  APPLICATION_REJECTION_LABEL:
    "加盟店が入力した手数料率を確認し、齟齬があれば申請を差し戻してください。",
  REJECT_REASON: "差戻理由",
  SALES_LABEL: "料率調整時に確認した、売上高を指定します。",
  SALES: "売上高",
  APPROVAL_NUMBER_UPDATE_LABEL: "契約書・料率通知書承認番号更新",
  DOCUMENT_CLASSIFICATION: "文書分類",
  CONTRACT_NAME: "契約名",
  APPROVAL_NUMBER: "承認番号",
  CONTRACT: "契約書",
  RATE_NOTICE: "契約通知書",
  APPROVAL_LABEL: "申請内容に不備がなければ承認してください。",
  COMMISSION_RATE_NONE: "手数料記載なし",
  COMMISSION_RATE_MISS: "手数料記載謝り",
} as const;
